import React from 'react';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { PropTypes as PT } from 'prop-types';
import chromeLogo from '../../assets/images/chrome-copy.png';
import './Unsupported.css';

const messages = defineMessages({
  getChrome: {
    id: 'getChrome',
    defaultMessage: 'Download Chrome'
  }
});

const Unsupported = props => (
  <div className="unsupportedHeader">
    <a href="https://www.google.com/chrome/browser">
      <img src={chromeLogo} alt={props.intl.formatMessage(messages.getChrome)} />
    </a>
    <h2 className="switchTitle">
      <FormattedMessage
        id="switchTitle"
        defaultMessage="Do you mind switching browsers?"
      />
    </h2>
    <div className="switchText">
      <FormattedMessage
        id="switchBodyFirst"
        defaultMessage="The Lifesize Share feature is not yet available on the browser you're using."
      />
    </div>
    <div className="switchText">
      <FormattedMessage
        id="switchBodySecond"
        defaultMessage="While we're working on adding support for your browser, please download or switch to Google Chrome."
      />
    </div>
    <div className="switchText">
      <FormattedMessage
        id="switchBodyThird"
        defaultMessage="Thank you."
      />
    </div>
  </div>
);

Unsupported.propTypes = {
  intl: PT.object
};

export default injectIntl(Unsupported);



// WEBPACK FOOTER //
// ./src/components/Unsupported/Unsupported.js